export default {
	// Recharge.vue
	recharge: '充值',
	rechargeTip: '①请将充值金额汇到以下汇款处。',
	rechargeTip2: '②请记载付款日期等汇款信息并发送。',
	payDate: '付款日期',
	rechargeType: '充值方式',
	tradeOrderNo: '交易订单号',
	payAccount: '付款账号',
	payUser: '付款人',
	amount: '金额',
	amountJPY: '金额（円）',
	amountJPYs: '充值金额（円）',
	amountCNY: '金额（元）',
	amountCNYs: '到账金额（元）',
	viewRechargeLog: '查看充值记录',
	submitSuccessTip: '提交成功，感谢您的支持，请等待财务人员审核入账。',
	rechargeAmount: '充值金额',
	submitTime: '提交时间',
	verificationCode: '验证码',
	verificationCodeTip: '看不清，换一张',
	verificationCodeError: '验证码不正确',
	bankTransfer: '银行转账',
	alipay: '支付宝',
	wechat: '微信',
	paypal: 'PayPal 结算',
	validMessage: '充值金额不能小于1000日元',
	// RechargeList.vue
	rechargeLog: '充值记录',
	userRechargeLog: '用户充值记录',
	rechargeNo: '充值流水号',
	auditing: '审核中',
	rechargeSuccess: '充值成功',
	rechargeFailed: '充值失败',
	cancelled: '已取消',
	orderOpr: '订单操作',
	tradeNo: '交易编号',
	userId: '用户ID',
	rechargeState: '充值状态',
	cancelRechargeConfirm: '确定取消本次充值记录吗',
	JPY: '日元',
	CNY: '元',
	tips: "帮我保存付款账号和付款人信息。",
	tipsPerson: "帮我保存付款人信息。",
	export: '导出凭证',
	queren: "请确认凭证上的姓名：",
	exchangeRate: '汇率',
	zcladd02: 'PayPal手续费(円)',
	add20240901: '如何汇款到支付宝？',
	add20240902: '在哪汇？',
	add20240903: '支付宝合作的境外汇款平台',
	add20240904: '汇款平台需要什么收款信息？',
	add20240905: '账号',
	add20240906: '姓',
	add20240907: '名',
	alipay: 'AliPay 结算'
};
